import {
  BorderAndShadowConfig,
  BoxShadowSize,
  LineStyleEnum
} from 'src/apollo/sites'
import { BOX_SHADOWS } from 'shared/components/common/button/useButtonsConfig'

export const lineStyleOptions = [
  { label: 'Solid', value: LineStyleEnum.Solid },
  { label: 'Dotted', value: LineStyleEnum.Dotted },
  { label: 'Dashed', value: LineStyleEnum.Dashed },
  { label: 'Double', value: LineStyleEnum.Double }
]

export const getBorderStyle = (
  borderAndShadowConfig?: BorderAndShadowConfig | null
) => {
  if (!borderAndShadowConfig?.showBorder) {
    return {}
  }
  const { borderWidth, borderStyle, borderColor } = borderAndShadowConfig || {}
  const style = borderStyle || 'solid'
  const width = `${borderWidth ?? 1}px`

  const result: Record<string, string> = {
    borderWidth: width,
    borderStyle: style
  }
  if (borderColor) {
    result.borderColor = borderColor
  }
  return result
}

export const getBoxShadowStyle = (
  borderAndShadowConfig?: BorderAndShadowConfig | null
) => {
  if (!borderAndShadowConfig?.showBoxShadow) {
    return {}
  }
  const shadow =
    BOX_SHADOWS[borderAndShadowConfig.boxShadowSize ?? BoxShadowSize.Md] ||
    BOX_SHADOWS[BoxShadowSize.Md]
  return { boxShadow: shadow }
}

/*
  Unlike the helpers above, this function allows for a default border radius to be passed in.
  This ensures that we can match styling previously defined by css (when config is null/flag is off).
*/
export const getBorderRadiusStyle = (
  borderAndShadowConfig?: BorderAndShadowConfig | null,
  defaultBorderRadius?: number
) => {
  const borderRadius = borderAndShadowConfig?.borderRadius

  // Handle numeric values (0-100)
  if (typeof borderRadius === 'number') {
    // Special case: 100 = fully rounded (pill shape)
    if (borderRadius === 100) {
      return { borderRadius: '9999px' }
    }

    // Linear mapping: 0-99 maps directly to 0-99px
    return { borderRadius: `${borderRadius}px` }
  }

  return { borderRadius: `${defaultBorderRadius ?? 0}px` }
}
